import { useMemo } from 'react';
import { PaymentItemStatusOptions } from '~graphql/__generated__/globalTypes';

export const usePaymentItemsIsAwaiting = (
  paymentItems: ({
    status: PaymentItemStatusOptions | null;
  } | null)[]
): Boolean => {
  return useMemo(() => {
    return paymentItems?.some(item => item?.status === PaymentItemStatusOptions.AWAITING);
  }, [paymentItems]);
};
